import React from 'react'
import { Route } from 'react-router-dom'
import AuthorizedComponent from 'src/components/Auth/AuthorizedComponent'
import Imports from 'src/modules/Imports'

const route = <Route path="/imports" element={<AuthorizedComponent component={Imports} />} />

export default route
